import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import Model from "@tripian/model";
import { api } from "@tripian/core";
import { saveNotification } from "../redux/action/user";

const useQuestionTrip = () => {
  const [loadingQuestionsTrip, setLoadingQuestionsTrip] =
    useState<boolean>(true);
  const [questionsTrip, setQuestionsTrip] = useState<Model.Question[]>();

  const dispatch = useDispatch();

  const fetchQuestionsTrip = useCallback(() => {
    setLoadingQuestionsTrip(true);
    return api
      .questionsTrip()
      .then((pQuestions: Model.Question[]) => {
        setQuestionsTrip(pQuestions);
      })

      .catch(questionsTripError => {
        dispatch(
          saveNotification(
            Model.NOTIFICATION_TYPE.ERROR,
            "questionTrip",
            "Fetch Trip Questions",
            questionsTripError
          )
        );
        throw questionsTripError;
      })
      .finally(() => {
        setLoadingQuestionsTrip(false);
      });
  }, [dispatch]);

  useEffect(() => {
    fetchQuestionsTrip();
  }, [fetchQuestionsTrip]);

  // Re-fetch when the app language changes — questionsTrip() is cached per-lang
  // server-side, but this hook otherwise only ever fetches once on mount.
  useEffect(() => {
    const handleLanguageChange = () => {
      fetchQuestionsTrip();
    };
    window.addEventListener("languageChanged", handleLanguageChange);
    return () =>
      window.removeEventListener("languageChanged", handleLanguageChange);
  }, [fetchQuestionsTrip]);

  return { loadingQuestionsTrip, questionsTrip };
};

export default useQuestionTrip;
